import {
  Button,
  Field,
  Input,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SurfaceRow,
} from '../../../../components/ui'
import type { TestSortMode } from './types'

const SORT_OPTIONS: Array<{ label: string; value: TestSortMode }> = [
  { value: 'recommended', label: 'Recommended' },
  { value: 'price-low', label: 'Price: low to high' },
  { value: 'price-high', label: 'Price: high to low' },
  { value: 'name-a-z', label: 'Name: A to Z' },
]

interface TestsCatalogControlsProps {
  searchQuery: string
  onSearchQueryChange: (query: string) => void
  sortMode: TestSortMode
  onSortModeChange: (mode: TestSortMode) => void
  popularOnly: boolean
  onTogglePopularOnly: () => void
  hasActiveFilters: boolean
  onResetFilters: () => void
}

export function TestsCatalogControls({
  searchQuery,
  onSearchQueryChange,
  sortMode,
  onSortModeChange,
  popularOnly,
  onTogglePopularOnly,
  hasActiveFilters,
  onResetFilters,
}: TestsCatalogControlsProps) {
  return (
    <SurfaceRow className="tests-controls-shell mt-4">
      <div className="tests-controls-grid">
        <Field>
          <Label htmlFor="tests-search-query">Search tests</Label>
          <Input
            id="tests-search-query"
            value={searchQuery}
            onChange={(event) => onSearchQueryChange(event.target.value)}
            placeholder="Search by panel, biomarker, or partner"
            className="tests-search-input"
          />
        </Field>

        <Field>
          <Label htmlFor="tests-sort-mode">Sort by</Label>
          <Select
            value={sortMode}
            onValueChange={(nextValue) => onSortModeChange(nextValue as TestSortMode)}
          >
            <SelectTrigger id="tests-sort-mode" className="tests-sort-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {SORT_OPTIONS.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
      </div>

      <div className="tests-controls-row">
        <Button
          type="button"
          variant="chip"
          onClick={onTogglePopularOnly}
          data-active={popularOnly ? 'true' : undefined}
        >
          Popular only
        </Button>

        <Button
          type="button"
          variant="chip"
          onClick={onResetFilters}
          disabled={!hasActiveFilters}
        >
          Reset filters
        </Button>
      </div>
    </SurfaceRow>
  )
}
